import {useFormValidation} from "~/composables/validations/useFormValidation";

export const validatePhoneMask = async (phone: string): Promise<ResponseApi> => {
    const { errors, validatePhone } = useFormValidation();
    const sanitizedPhone = phone.replace(/\D/g, '');
    validatePhone(sanitizedPhone);
    if (errors.value.phone_number) {
        return {
            status: false,
            error: errors.value.phone_number
        };
    }
    return {
        status: true,
        data: sanitizedPhone
    };
};